import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ImpersonationService {
  private readonly key = 'impersonatedTeacher';
  private readonly secretKey = 'YourStrongSecretKey123!'; 


    private impersonationChangedSource = new BehaviorSubject<boolean | null>(false);
  impersonationChanged$ = this.impersonationChangedSource.asObservable();

 
  setImpersonatedTeacher(employee: any): void {
    if (employee) {
      const encrypted = CryptoJS.AES.encrypt(
        JSON.stringify(employee),
        this.secretKey
      ).toString();
      
     

      sessionStorage.setItem(this.key, encrypted);

      Promise.resolve().then(() => {
        this.impersonationChangedSource.next(true);
      });
    } else {
      sessionStorage.removeItem(this.key);
      this.impersonationChangedSource.next(false)
    }
  }


  getImpersonatedTeacher(): any {
    const encrypted = sessionStorage.getItem(this.key);
    if (encrypted) {
      try {
        const bytes = CryptoJS.AES.decrypt(encrypted, this.secretKey);
        const decrypted = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(decrypted);
      } catch (e) {
        console.error('Error decrypting impersonation data', e);
        return null;
      }
    }
    return null;
  }


  clearImpersonation(): void {
    sessionStorage.removeItem(this.key);
  }


  isImpersonating(): boolean {
    return !!sessionStorage.getItem(this.key);
  }
}
